import { render, staticRenderFns } from "./ListFaqPage.vue?vue&type=template&id=a53a7a0a"
import script from "./ListFaqPage.vue?vue&type=script&lang=js"
export * from "./ListFaqPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports